// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"246f76c0","977":"97e53e9e"}[chunkId] + ".chunk.js";
};